/****
 * Footer component that provides application-wide navigation links,
 * branding, and copyright information.
 */
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import darajaLogo from "@/assets/images/darajaLogo.svg";

export default function Footer() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <footer className="relative z-[999] w-full border-t border-neutral-700 bg-neutral-900 text-white">
        <div className="relative mx-auto flex max-w-screen-2xl items-start md:items-center justify-start sm:justify-between px-6 md:px-20 py-6 gap-6 md:gap-10">
          {" "}
          {/* LOGO (ALWAYS VISIBLE) */}
          <img
            src={darajaLogo}
            alt={t("components.footer.logoAlt")}
            className="h-10 w-auto cursor-pointer flex-shrink-0"
            onClick={() => navigate("/", { replace: true })}
          />
          <nav
            className="
    hidden sm:flex
    sm:flex-col sm:items-center sm:gap-2
    lg:flex-row lg:gap-8
    text-sm text-neutral-300 text-center
    flex-1
  "
          >
            {/* Accessibility → hover only */}
            <a
              href="https://mastercardfdn.org/en/accessibility/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white"
            >
              {t("components.footer.links.accessibility")}
            </a>
            {/* <div className="relative group cursor-not-allowed">
              <span className="hover:text-white">{t("components.footer.links.accessibility")}</span>
              <div className="absolute left-1/2 top-full z-10 mt-2 hidden -translate-x-1/2 whitespace-nowrap rounded bg-black px-3 py-1 text-xs text-white group-hover:block">
                Page Coming Soon
              </div>
            </div> */}

            <a
              href="https://mastercardfdn.org/en/privacy/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white"
            >
              Privacy Statement
            </a>

            <a
              href="https://cdn.buttercms.com/YefbC9GvRMCcH6pSjkzv"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white"
            >
              {t("components.footer.links.safeguarding")}
            </a>
          </nav>
          {/* COPYRIGHT (ALWAYS VISIBLE, CENTERED ON MOBILE) */}
          <span className="text-neutral-400 text-sm whitespace-nowrap flex-shrink-0 text-right">
            {t("components.footer.copyright")}
          </span>
        </div>
      </footer>
    </>
  );
}
``;
